import { useEffect, useState } from "react";
import { memberApi } from "@/member/api";

export default function FacilitationAssistanceOffer() {
  const [offer, setOffer] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => { memberApi.get("/payments/board-fundraising-assistance").then(r => setOffer(r.data)).catch(() => {}); }, []);
  if (!offer?.eligible && !offer?.purchased) return null;
  const buy = async () => {
    setBusy(true); setError("");
    try {
      const response = await memberApi.post("/payments/board-fundraising-assistance/checkout", { origin_url: window.location.origin });
      window.location.assign(response.data.checkout_url);
    } catch (err) { setError(err.response?.data?.detail || "Checkout could not be opened."); setBusy(false); }
  };
  return <div className="bfg-clean-stage" data-testid="bfg-facilitation-assistance">
    {offer.purchased ? <><h3>Your facilitation assistance is confirmed</h3><p>Rooney can help facilitate your Group Game in this organisation's existing dashboard. Your purchase is recorded for the owner to arrange the next step.</p></>
      : <><h3>Would you like Rooney to facilitate your Group Game?</h3><p>You can add facilitation assistance for $997 while keeping your self-guided programme and this organisation dashboard.</p>
        <button className="bfg-btn bfg-btn-primary" disabled={busy} onClick={buy}>{busy ? "Opening checkout…" : "Add Group Game facilitation — $997"}</button></>}
    {error && <p role="alert">{error}</p>}
  </div>;
}
